import { create } from 'zustand';

/** errorCode the backend returns (403) for anything a partner may not do before e-signing the agreement. */
export const AGREEMENT_PENDING = 'AGREEMENT_PENDING';

interface AgreementPopupStore {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

// Kept free of other imports: NetworkManager opens it on a 403 AGREEMENT_PENDING.
export const useAgreementPopupStore = create<AgreementPopupStore>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}));
